import React from "react";
import About from "../components/about";
import Tracks from "../components/tracks";
import FAQ from "../components/faq";

function Info() {
  return (
    <div>
      <About />
      <Tracks />
      <FAQ />
    </div>
  );
}

export default Info;